import axios from "axios";
import { TNiuStatsEventHandler } from "./useNiuStats.types";

class niuStatsProvider {
    fetching: boolean;

    private readonly subscriptions: Set<TNiuStatsEventHandler>;
    private timeout: ReturnType<typeof setTimeout>;

    constructor() {
        this.subscriptions = new Set();
    }

    subscribe(handler: TNiuStatsEventHandler) {
        this.subscriptions.add(handler);

        this.start();

        return this.unsubscribeCallback(handler);
    }

    unsubscribe(handler: TNiuStatsEventHandler) {
        this.unsubscribeCallback(handler)();
    }

    private unsubscribeCallback(handler: TNiuStatsEventHandler) {
        return () => {
            this.subscriptions.delete(handler);

            this.end();
        };
    }

    private start() {
        if (this.subscriptions.size <= 0) {
            return;
        }

        if (this.timeout) {
            return;
        }

        this.timeout = setInterval(this.run.bind(this), 6000);
        this.run();
    }

    private end() {
        if (this.subscriptions.size > 0) {
            return;
        }

        if (!this.timeout) {
            return;
        }

        clearTimeout(this.timeout);
    }

    private run() {
        //if the request is already running we dont need to run it again
        //or if the browser tab is not open we dont want to request the stats from the api
        if (this.fetching || document?.hidden) {
            return;
        }

        this.fetching = true;
        axios
            .get("/wp-content/plugins/tmp/api/niuStats.php")
            .then((response) => {
                if (response.status === 200) {
                    this.subscriptions.forEach((listener) => listener(response.data));
                }
            })
            .finally(() => {
                this.fetching = false;
            });
    }
}

const niuStatsSingleton = new niuStatsProvider();

export default niuStatsSingleton;
